document.addEventListener('DOMContentLoaded', function() {
  const QUALIFYING_PROP = '_qualifying_for_gift';
  const GIFT_PROP = 'Free Gift';
  const GIFT_VARIANTS = ['57035377344837', '57035377377605']; // Beige and Black variant IDs
  
  // Main validation function
  async function validateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Count total qualifying items
      let qualifyingCount = 0;
      let giftItems = [];
      
      cart.items.forEach(item => {
        if (item.properties && item.properties[QUALIFYING_PROP] === 'true') {
          qualifyingCount += item.quantity;
        }
        if (item.properties && item.properties[GIFT_PROP] === 'Yes') {
          giftItems.push(item);
        }
      });
      
      console.log('Qualifying items:', qualifyingCount, 'Gift items:', giftItems.length);
      
      // If no qualifying items, remove all gifts
      if (qualifyingCount === 0 && giftItems.length > 0) {
        await removeGiftItems(giftItems);
        return;
      }
      
      // If qualifying items exist, sync gift quantity
      if (qualifyingCount > 0) {
        const currentGiftQuantity = giftItems.reduce((sum, item) => sum + item.quantity, 0);
        
        if (currentGiftQuantity !== qualifyingCount) {
          await syncGiftQuantity(giftItems, qualifyingCount, cart);
        }
      }
    } catch (error) {
      console.error('Cart validation error:', error);
    }
  }
  
  // Remove all gift items
  async function removeGiftItems(giftItems) {
    const updates = {};
    giftItems.forEach(item => {
      updates[item.key] = 0;
    });
    
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    
    refreshCartUI();
  }
  
  // Sync gift quantity to match qualifying count
  async function syncGiftQuantity(giftItems, targetQuantity, cart) {
    // Remove existing gifts first
    const updates = {};
    giftItems.forEach(item => {
      updates[item.key] = 0;
    });
    
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    
    // Add new gift with correct quantity (use first variant as default, or random)
    const giftVariantId = GIFT_VARIANTS[0]; // Default to beige
    
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: giftVariantId,
        quantity: targetQuantity,
        properties: { [GIFT_PROP]: 'Yes' }
      })
    });
    
    refreshCartUI();
  }
  
  // Refresh cart display
  function refreshCartUI() {
    // Try multiple methods to refresh
    if (document.querySelector('cart-drawer')) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (typeof cartDrawer.render === 'function') {
        cartDrawer.render();
      } else {
        // Force reload section
        fetch('/cart?view=drawer')
          .then(r => r.text())
          .then(html => {
            const temp = document.createElement('div');
            temp.innerHTML = html;
            const newDrawer = temp.querySelector('cart-drawer');
            if (newDrawer && cartDrawer) {
              cartDrawer.innerHTML = newDrawer.innerHTML;
            }
          });
      }
    } else if (window.location.pathname === '/cart') {
      window.location.reload();
    }
  }
  
  // Watch for cart changes
  document.addEventListener('cart:updated', validateCart);
  document.addEventListener('cart:change', validateCart);
  
  // Watch for quantity changes in cart
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="updates[]"], .cart__quantity-input, [data-quantity-input]')) {
      setTimeout(validateCart, 800); // Wait for Shopify to process
    }
  });
  
  // Watch for remove clicks
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-cart-remove], .cart-remove, .remove-btn, [data-remove]') || 
        e.target.closest('[data-cart-remove], .cart-remove, .remove-btn, [data-remove]')) {
      setTimeout(validateCart, 1000);
    }
  });
  
  // Run on cart page load
  if (window.location.pathname === '/cart') {
    validateCart();
  }
  
  // Also run when cart drawer opens
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList && mutation.target.classList.contains('drawer--open')) {
        validateCart();
      }
    });
  });
  
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }
});